<template>
  <div class="mb-5">
    <p class="text-sm text-gray-500 leading-tight font-light text-center">
      Selecione as disciplinas que você quer estudar. Você sempre poderá mudar
      depois essas configurações. E não se esquece de dar
      <strong>Foco Extra</strong> naquelas que quiser aprender mais!
    </p>

    <!-- Toggle Button -->
    <div class=" flex items-center justify-center">
      <label
        for="toogleA"
        class="flex items-center justify-center cursor-pointer"
      >
        <div class="relative">
          <input
            id="toogleA"
            type="checkbox"
            class="hidden"
            @change="handleClickSelectAllDisciplines"
            v-model="allSelected"
          />
          <div
            class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
          ></div>
          <div
            class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
          ></div>
        </div>
        <div class="ml-3 text-gray-700 font-medium">
          <span v-if="allSelected">Desmarcar</span
          ><span v-else>Marcar</span> Todas!
        </div>
      </label>
    </div>

    <div v-for="(discipline, key) in disciplines" :key="key">
      <DisciplineButton
        v-on:clickedSelect="handleClickedSelect"
        v-on:clickedExtraFocus="handleClickedExtraFocus"
        :discipline="discipline"
        :ref="`discipline-${discipline.id}`"
      />
    </div>
  </div>
</template>

<script>
import DisciplineButton from "./DisciplineButton.vue";

export default {
  name: "Disciplines",
  components: {
    DisciplineButton
  },
  data() {
    return {
      disciplines: [],
      allSelected: false,
      allDisciplines: []
    };
  },
  created() {
    this.$http("disciplines").then(response => {
      this.allDisciplines = response.data.data;

      this.$http(`/users/${this.$store.getters.user.id}/disciplines`)
        .then(response => {
          const selectedDisciplines = response.data.data;

          this.disciplines = this.allDisciplines.map(discipline => {
            let selected = false;
            let extra_focus = false;

            selectedDisciplines.find(selectedDiscipline => {
              if (selectedDiscipline.id === discipline.id) {
                selected = true;
                extra_focus = selectedDiscipline.extra_focus ? true : false;

                return true;
              }
              return false;
            });

            return {
              id: discipline.id,
              shortname: discipline.shortname,
              extra_focus: extra_focus,
              selected: selected
            };
          });

          // Vamos ver se já temos todas marcadas, para que o toggle button esteja correto.
          if (
            this.disciplines.filter(discipline => discipline.selected == true)
              .length === this.allDisciplines.length
          ) {
            this.allSelected = true;
          } else {
            this.allSelected = false;
          }
        })

        .catch(() => {
          this.$toasted.error("Ops... parece que deu alguma coisa errada...");
        });
    });
  },
  methods: {
    handleClickedSelect(disciplineId) {
      this.disciplines.map(discipline => {
        if (discipline.id === disciplineId) {
          discipline.selected = !discipline.selected;

          // se tirou a disciplina, temos que tirar o extra foco.
          if (discipline.selected == false) {
            this.setDisciplineProperty(discipline, "extra_focus", false);
          }
        }

        return discipline;
      });

      this.sendNewDisciplinesArray();
    },
    handleClickedExtraFocus(disciplineId) {
      this.disciplines.map(discipline => {
        if (discipline.id === disciplineId)
          discipline.extra_focus = !discipline.extra_focus;

        // se clicou no extra foco mas disciplina não estava selecionada, temos que selecionar
        if (discipline.extra_focus == true) {
          this.setDisciplineProperty(discipline, "selected", true);
        }
        return discipline;
      });

      this.sendNewDisciplinesArray();
    },

    setDisciplineProperty(disciplineToSet, property, status) {
      this.disciplines.map(discipline => {
        if (discipline.id === disciplineToSet.id) {
          discipline[property] = status;
        }
        return discipline;
      });
    },

    sendNewDisciplinesArray() {
      const postArray = this.disciplines
        .filter(discipline => discipline.selected)
        .map(discipline => {
          if (discipline.selected) {
            return {
              discipline_id: discipline.id,
              extra_focus: discipline.extra_focus
            };
          }
        });

      this.$http
        .post(`users/${this.$store.getters.user.id}/disciplines`, postArray)
        .then()
        .catch(() => {
          this.$toasted.error("Ops... parece que deu alguma coisa errada...");
        });
    },
    handleClickSelectAllDisciplines() {
      this.disciplines = this.allDisciplines.map(discipline => {
        return {
          id: discipline.id,
          shortname: discipline.shortname,
          extra_focus: false,
          selected: this.allSelected
        };
      });

      if (this.allSelected) {
        this.disciplines = this.disciplines.map(discipline => {
          discipline.selected = true;
          // se tirou a disciplina, temos que tirar o extra foco.
          if (discipline.selected == true) {
            this.setDisciplineProperty(discipline, "extra_focus", false);
          }

          return discipline;
        });
      }
      this.sendNewDisciplinesArray();
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #f79b77;
}
</style>
